import { usePropertyInventory } from "../../../../../hooks/usePropertyInventory";
import { Button, Card, CardContent, CircularProgress, Paper, Snackbar, Typography } from "@mui/material";
import { alpha, Box } from "@mui/system";
import { Apartment, ArrowBack, ArrowForward, DirectionsCar } from "@mui/icons-material";
import { getComplexTypeText } from "../../../../../utils/constants";
import { useState } from "react";

export const Step2ConfigureApartments = () => {
  const { currentStep, setCurrentStep, apartmentComplex, 
    isLoading, errorMessage} = usePropertyInventory();
  const [openSnackbar, setOpenSnackbar] = useState(false);
 
  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent sx={{ p: 4 }}>
        <Typography variant="h5" fontWeight="bold" color="#2E7D7A" sx={{ mb: 3 }}>
          Confirmación del Complejo de Propiedades
        </Typography>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Complejo: <strong>{apartmentComplex?.name || 'Sin nombre'}</strong>
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Número de pisos en el Complejo: <strong>{apartmentComplex?.totalFloors || 0}</strong>
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Número de Parqueos Disponibles: <strong>{apartmentComplex?.totalParkingSpaces || 0}</strong>
          </Typography>
        </Box>

        {/* Vista previa del mapa de apartamentos */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>Vista Previa del Complejo</Typography>
          <Paper sx={{ p: 3, backgroundColor: '#FAFAFA', borderRadius: 2 }}>
            <Box sx={{ 
              display: 'grid', 
              gridTemplateColumns: `repeat(${Math.ceil(Math.sqrt(apartmentComplex?.totalFloors || 1))}, 1fr)`,
              gap: 2,
              maxWidth: 600
            }}>
              {Array.from({ length: apartmentComplex?.totalFloors || 0 }, (_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: 40,
                    height: 40,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    border: '2px solid #4DB6AC',
                    backgroundColor: alpha('#4DB6AC', 0.1),
                  }}
                >
                  <Apartment sx={{ color: '#4DB6AC', mb: 0.5, fontSize: { xs: 18, sm: 20, md: 22 } }} />
                  <Typography variant="caption" fontWeight="bold" color="#2E7D7A">
                    #{index + 1}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Box>

        {/* Selección del número de parqueos */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>Vista Previa de los parqueos</Typography>
          <Paper sx={{ p: 3, backgroundColor: '#FAFAFA', borderRadius: 2 }}>
            <Box sx={{ 
              display: 'grid', 
              gridTemplateColumns: `repeat(${Math.ceil(Math.sqrt(apartmentComplex?.totalParkingSpaces || 0))}, 1fr)`,
              gap: 2,
              maxWidth: 600
            }}>
              {Array.from({ length: apartmentComplex?.totalParkingSpaces || 0 }, (_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: 40,
                    height: 40,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 2,
                    border: '2px solid #4DB6AC',
                    backgroundColor: alpha('#4DB6AC', 0.1),
                  }}
                >
                  <DirectionsCar sx={{ color: '#4DB6AC', mb: 0.5, fontSize: { xs: 18, sm: 20, md: 22 } }} />
                  <Typography variant="caption" fontWeight="bold" color="#2E7D7A">
                    #{index + 1}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Box>

        {/* Botones de navegación */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={handlePrevious}
            sx={{ 
              borderColor: '#4DB6AC',
              color: '#4DB6AC',
              '&:hover': {
                borderColor: '#26A69A',
                backgroundColor: alpha('#4DB6AC', 0.1)
              }
            }}
          >
            Anterior
          </Button>
          
          <Button
            variant="contained"
            endIcon={<ArrowForward />}
            onClick={handleNext}
            sx={{
              backgroundColor: '#4DB6AC',
              '&:hover': {
                backgroundColor: '#26A69A',
              }
            }}
          >
            {isLoading ?
            <CircularProgress size={24} color="inherit" />
            :
            'Crear ' + getComplexTypeText(apartmentComplex?.typeOfComplex || 1)
            }
          </Button>
        </Box>
      </CardContent>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message={errorMessage || "Operación exitosa"}
      />
    </Card>
  );
}